module.exports = __webpack_public_path__ + "static/media/railsImg.62303bfa.png";